import { getHandle } from 'utils/router/utils/getHandle'

// Shared by the web and ICON magic-link routes so their query params can't drift apart
const MAGIC_LINK_AUTH_QUERY = ['token', 'source', 'refId', 'preset', 'return', 'next_path'] as const

export const SigninProfileRoutes = [
  {
    path: 'selectChannel',
    handle: getHandle('registration'),
    lazy: () => import('./FirstSelectChannel/FirstSelectChannel.page'),
  },
  {
    path: 'telegramAuth',
    handle: getHandle('auth'),
    alias: 'telegramAuth',
    query: ['channel', 'is_signup', 'return', 'regSource', 'next_path', 'state'],
    lazy: () => import('./TelegramAuth/TelegramAuth.page'),
  },
] as const

export const SigninRoutes = [
  {
    path: 'signup',
    handle: getHandle('auth'),
    alias: 'signup',
    query: ['return', 'regSource', 'next_path', 'preset', 'refId'],
    lazy: () => import('./SignUpPage/SignUp.page'),
  },
  {
    path: 'telegramAuth',
    handle: getHandle('auth'),
    alias: 'telegramAuth',
    query: ['channel', 'is_signup', 'return', 'regSource', 'next_path', 'state'],
    lazy: () => import('./TelegramAuth/TelegramAuth.page'),
  },
  {
    path: 'facebookAuth',
    handle: getHandle('auth'),
    alias: 'facebookAuth',
    query: ['channel', 'return', 'regSource', 'next_path'],
    lazy: () => import('./FacebookAuth/FacebookAuth.page'),
  },
  {
    path: 'signin',
    handle: getHandle('auth'),
    alias: 'signin',
    query: ['return', 'error', 'provider', 'regSource', 'next_path', 'preset'],
    lazy: () => import('./SignInPage/SignIn.page'),
  },
  {
    path: 'login',
    handle: getHandle('auth'),
    lazy: () => import('./SignInPage/SignIn.page'),
  },
  {
    path: 'auth/magic',
    handle: getHandle('auth'),
    alias: 'magicLinkAuth',
    query: MAGIC_LINK_AUTH_QUERY,
    lazy: () => import('./MagicLinkAuth/MagicLinkAuth.page'),
  },
  // ICON magic-link emails land here when the ICON app isn't installed: same flow as the web link
  {
    path: 'auth/magic/icon',
    handle: getHandle('auth'),
    alias: 'magicLinkAuthIcon',
    query: MAGIC_LINK_AUTH_QUERY,
    lazy: () => import('./MagicLinkAuth/MagicLinkAuth.page'),
  },
  {
    path: 'auth/user/recovery/email-auth',
    handle: getHandle('auth'),
    alias: 'recoveryEmailAuth',
    query: ['token', 'device', 'location', 'time'],
    lazy: () => import('./AccountRecovery/EmailAuthRecovery.page'),
  },
  {
    path: 'auth/user/recovery/email-change',
    handle: getHandle('auth'),
    alias: 'recoveryEmailChange',
    query: ['token', 'new_email', 'time'],
    lazy: () => import('./AccountRecovery/EmailChangeRecovery.page'),
  },
  {
    path: 'signup/oneTap',
    handle: getHandle('auth'),
    alias: 'oneTapCaptcha',
    lazy: () => import('./OneTapCaptcha/OneTapCaptcha.page'),
  },
] as const
